module.exports = __webpack_public_path__ + "img/pieces.72db71f2.svg";